import questionData from "./question_data";
/* 탭별 테이블 구성 콜백 함수 */
let makeGrid = (num) => {
    let page_num;
    let itemData = questionData[num];
    let init_element='';
    if(num >= 16){//16이상이 챕터 3
        let talk_box_num = num-15;
        if(num>21&&num<25){
            talk_box_num = 7;
        }else if(num>=25){
            talk_box_num = num-17;
        }
        init_element+= `
        <table class="p-sec2__question-table2">
            <tr><td class="p-sec2__talk-box--${talk_box_num}" style="height: 324px;"></td></tr>
        </table>`;
    }
    init_element+=`<table id="question_table_${num}" class="p-sec2__question-table">`
    // 문항 루프
    let elementString = itemData.reduce((pre,ele,idx) => {
        page_num = ele.page;

        //답변 루프
        pre += ele.answer.reduce((preElement,element,index)=>{
            if(ele.answerType === 'text'){
                preElement += `${element}`;
            }else{
                preElement += `<${ele.wrap} class="p-sec2__question-input" style="width: ${ele.width}px; display: ${ele.wrap==='div'?'block':'inline-block'}">
                                <input type="${ele.answerType}" name="answer_${ele.page}_${idx}" id="answer_${ele.chapter}_${ele.page}_${idx}_${index}" 
                                    data-chapter="${ele.chapter}"
                                    data-page="${ele.page}"
                                    data-question="${idx+1}"
                                    data-answer="${index+1}"
                                />
                                <label for="answer_${ele.chapter}_${ele.page}_${idx}_${index}"></label>${element}
                              </${ele.wrap}>`;
            }
            return preElement;
        },`<tr><td><div><span></span>${ele.subject}</div><div>`);
        pre+='</div></td></tr>';
        return pre;
    },init_element);
    elementString += '<tr><td>';

    //레이어 버튼 처리.
    if(num===19){
        elementString +=`<button class="p-btn p-btn__dungeon"></button>`;
    }else if(num===20){
        elementString +=`<button class="p-btn p-btn__field"></button>`;
    }
    elementString += `<button data-num="${num*1}" data-count="${itemData.length}" data-page="${page_num}" class="p-btn p-btn__next"></button>
                        <span class="p-sec2__page"><font color="#ff9999">${page_num}</font>/21</span>
                      </td></tr></table>`;
    document.querySelector(`#question_grid`).innerHTML = elementString;
}


export default makeGrid;
